/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_InitializingInputs */

const en_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initializing OCR engine...`)
};

const fr_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialisation du moteur OCR...`)
};

const de_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Engine wird initialisiert...`)
};

const it_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizializzazione del motore OCR in corso...`)
};

const ru_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инициализация механизма распознавания текста...`)
};

const es_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando el motor OCR...`)
};

const zh_cn2_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在初始化OCR引擎……`)
};

const ja_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCRエンジンを初期化しています...`)
};

const hi_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR इंजन प्रारंभ हो रहा है...`)
};

const pt_pt2_ocr_initializing = /** @type {(inputs: Ocr_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando o mecanismo de OCR...`)
};

/**
* | output |
* | --- |
* | "Initializing OCR engine..." |
*
* @param {Ocr_InitializingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_initializing = /** @type {((inputs?: Ocr_InitializingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_InitializingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_initializing(inputs)
	if (locale === "de") return de_ocr_initializing(inputs)
	if (locale === "it") return it_ocr_initializing(inputs)
	if (locale === "ru") return ru_ocr_initializing(inputs)
	if (locale === "es") return es_ocr_initializing(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_initializing(inputs)
	if (locale === "ja") return ja_ocr_initializing(inputs)
	if (locale === "hi") return hi_ocr_initializing(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_initializing(inputs)
	return en_ocr_initializing(inputs)
});